export default __webpack_public_path__ + "static/media/liberum-12.1c5679fd.png";